import { combineReducers } from 'redux';

import authenticityToken from './authenticityToken';
import sessionToken from './sessionToken';
import analytics from './analytics';
import creditApplication from './creditApplication';
import instantCredit from './instantCredit';
import iovation from './iovation';
import storeLocations from './storeLocations';
import tenant from './tenant';
import timeouts from './timeouts';
import prescreen from './prescreen';
import otpCode from './otpCode';
import prequalOffer from './prequalOffer';
import financeOffers from './financeOffers';
import initialFinanceOffers from './initialFinanceOffers';
import consumerSearch from './consumerSearch';
import driversLicense from './driversLicense';
import enhancedCheckout from './enhancedCheckout';
import membershipValidation from './membershipValidation';
import unifiedWidgets from './unifiedWidgets';
import twoWayHybridApply from './twoWayHybridApply';
import cachedAttributes from './cachedAttributes';
import tenantLogo from './tenantLogo';
import unifiedIssuance from './unifiedIssuance';
import correlationId from './correlationId';

const reducer = combineReducers({
  authenticityToken,
  sessionToken,
  analytics,
  creditApplication,
  instantCredit,
  iovation,
  storeLocations,
  tenant,
  timeouts,
  prescreen,
  otpCode,
  prequalOffer,
  financeOffers,
  initialFinanceOffers,
  consumerSearch,
  driversLicense,
  enhancedCheckout,
  membershipValidation,
  unifiedWidgets,
  twoWayHybridApply,
  cachedAttributes,
  tenantLogo,
  unifiedIssuance,
  correlationId,
});

export default reducer;

export type State = ReturnType<typeof reducer>;
